import React, { useMemo } from 'react';
import { Divider, Grid, Typography } from '@mui/material';
import TextField from 'libs/formik_fields/TextField';

import { useFormikContext } from 'formik';
import DateInputField from '../../libs/formik_fields/DateInputField';
import RadioGroupField from '../../libs/formik_fields/RadioGroupField';
import SelectField from '../../libs/formik_fields/SelectField';

function QuestionField({ question, index }) {
    const formik = useFormikContext();
    const inputDataLength = useMemo(() => {
        const text = formik.values?.questions[index]?.answerText ?? '';
        return text.length;
    }, [formik.values, index]);
    return (
        <Grid container spacing={2} key={index}>
            <Grid item xs={12}>
                <Typography variant="h3">{question.heading}</Typography>
            </Grid>
            {question.questionType === 'TEXT_BOX' && (
                <>
                    <Grid item xs={12}>
                        <Typography variant="h4" style={{ color: '#8d9498', fontWeight: 400 }}>
                            {question.question}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            size="small"
                            name={`questions[${index}].answerText`}
                            required={question.isQuestionRequired}
                            label="Answer"
                            showErrorText={false}
                            inputProps={{ maxLength: question.characterLimit }}
                        />
                    </Grid>
                </>
            )}
            {question.questionType === 'EMAIL' && (
                <>
                    <Grid item xs={12}>
                        <Typography variant="h4 " style={{ color: '#8d9498', fontWeight: 400 }}>
                            {question.question}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            type="email"
                            fullWidth
                            size="small"
                            name={`questions["${index}"].answerText`}
                            required={question.isQuestionRequired}
                            label="Answer"
                            showErrorText={false}
                        />
                    </Grid>
                </>
            )}
            {question.questionType === 'TEXT_AREA' && (
                <>
                    <Grid item xs={12}>
                        <Typography variant="h4" style={{ color: '#8d9498', fontWeight: 400 }}>
                            {question.question}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            size="small"
                            name={`questions[${index}].answerText`}
                            required={question.isQuestionRequired}
                            label="Answer"
                            multiline
                            rows={4}
                            showErrorText={false}
                            inputProps={{ maxLength: question.characterLimit }}
                        />
                    </Grid>
                </>
            )}
            {question.questionType === 'CALENDAR' && (
                <>
                    <Grid item xs={12}>
                        <Typography variant="h4" style={{ color: '#8d9498', fontWeight: 400 }}>
                            {question.question}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <DateInputField
                            fullWidth
                            size="small"
                            name={`questions[${index}].answerText`}
                            label="Answer"
                            multiline
                            rows={4}
                            showErrorText={false}
                        />
                    </Grid>
                </>
            )}
            {question.questionType === 'RADIO_BUTTON' && (
                <>
                    <Grid item xs={12}>
                        <Typography variant="h4" style={{ color: '#8d9498', fontWeight: 400 }}>
                            {question.question}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <RadioGroupField
                            fullWidth
                            size="small"
                            name={`questions[${index}].answerId`}
                            label="Answer"
                            showErrorText={false}
                            options={question.profileQuestionOptions}
                            valueKey="_id"
                            labelKey="name"
                        />
                    </Grid>
                </>
            )}
            {question.questionType === 'DROP_DOWN' && question.profileQuestionOptions.length > 0 && (
                <>
                    <Grid item xs={12}>
                        <Typography variant="h4" style={{ color: '#8d9498', fontWeight: 400 }}>
                            {question.question}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <SelectField
                            fullWidth
                            size="small"
                            name={`questions[${index}].answerId`}
                            label="Answer"
                            showErrorText={false}
                            options={question.profileQuestionOptions}
                            valueKey="_id"
                            labelKey="name"
                        />
                    </Grid>
                </>
            )}
            {['TEXT_BOX', 'TEXT_AREA'].includes(question.questionType) && question.characterLimit !== 0 && (
                <>
                    <Grid item xs={12}>
                        {question.characterLimit - inputDataLength >= 0 ? (
                            <Typography variant="body1">{`${question.characterLimit - inputDataLength} character(s) remaining`}</Typography>
                        ) : (
                            <Typography variant="body1" color="error">
                                {`Answer character(s) limit reached. Only ${question.characterLimit} character(s) are allowed.`}
                            </Typography>
                        )}
                    </Grid>
                </>
            )}
        </Grid>
    );
}

export default QuestionField;
